import CustomError from './CustomError'

export default class TokenMalformedException extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
